import React from 'react';
import {RegulationComponentsCommon} from "../../regulation-components-common";
import {ResponsibleGamingButtonsGermanyComponent} from "../../../../components/responsible-gambling/responsible-gaming-buttons/regulations/germany/responsible-gaming-buttons-germany.component";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../../common/const/responsible-gaming";

export class GermanyRegulationComponents extends RegulationComponentsCommon {
    renderHeaderRegulationIcons() {
        return (
            <ResponsibleGamingButtonsGermanyComponent placement={GermanyResponsibleGamingButtonPlacement.inHeader}/>
        );
    }
}